import type { SetupCompletionPayload, SetupWizardForm } from '../../types'

const trimToDefault = (value: string | undefined, fallback = ''): string => value?.trim() || fallback

export const buildSetupWizardPayload = (form: SetupWizardForm): SetupCompletionPayload => ({
  owner: {
    password: trimToDefault(form.owner.password),
    displayName: trimToDefault(form.owner.fullName),
    email: trimToDefault(form.owner.email),
  },
  storeIdentity: {
    storeName: trimToDefault(form.storeIdentity.storeName),
    timezone: trimToDefault(form.storeIdentity.timezone),
    currency: trimToDefault(form.storeIdentity.currency),
    primaryDomain: trimToDefault(form.storeIdentity.primaryDomain),
  },
  onboardingPreferences: {
    paymentStrategy: form.onboardingPreferences.paymentStrategy,
    emailProvider: form.onboardingPreferences.emailProvider,
    botProtection: form.onboardingPreferences.botProtection,
  },
  paymentSetup: {
    providerId: form.paymentSetup.providerId,
    stripe: {
      stripeMode: form.paymentSetup.stripe.stripeMode,
      publishableKey: trimToDefault(form.paymentSetup.stripe.publishableKey),
      secretKey: trimToDefault(form.paymentSetup.stripe.secretKey),
      webhookSecret: trimToDefault(form.paymentSetup.stripe.webhookSecret),
    },
    bankTransfer: {
      beneficiaryName: trimToDefault(form.paymentSetup.bankTransfer.beneficiaryName),
      iban: trimToDefault(form.paymentSetup.bankTransfer.iban),
      bicSwift: trimToDefault(form.paymentSetup.bankTransfer.bicSwift),
      bankName: trimToDefault(form.paymentSetup.bankTransfer.bankName),
      paymentInstructions: trimToDefault(form.paymentSetup.bankTransfer.paymentInstructions),
      paymentTimeoutDays: form.paymentSetup.bankTransfer.paymentTimeoutDays,
    },
  },
  emailSetup: {
    providerId: form.emailSetup.providerId,
    smtp: {
      host: trimToDefault(form.emailSetup.smtp.host),
      port: form.emailSetup.smtp.port,
      secure: form.emailSetup.smtp.secure,
      username: trimToDefault(form.emailSetup.smtp.username),
      password: trimToDefault(form.emailSetup.smtp.password),
      fromName: trimToDefault(form.emailSetup.smtp.fromName),
      fromEmail: trimToDefault(form.emailSetup.smtp.fromEmail),
      replyToEmail: trimToDefault(form.emailSetup.smtp.replyToEmail),
    },
  },
  botProtectionSetup: {
    providerId: form.botProtectionSetup.providerId,
  },
})

export const clearSetupWizardQuery = () => {
  const basePath = window.location.pathname.split('?')[0]
  window.history.replaceState({}, '', basePath)
}
